import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { Button } from "@/components";
import { DownloadIcon } from "@/components/atoms/icons";
import { useNotificationNamek } from "@/features/notifications";
import { DownloadFileErrorMessage, DownloadFileSuccessMessage } from "@/constants/commonMessages";

import { useGetAllAssignMaterials } from "../../services/useGetAllAssignMaterials";
import { exportAssignedMaterials } from "../../services/exportAssignedMaterials";

export function ExportAssignedMaterialsBtn() {
  const queryClient = useQueryClient();
  const { toast } = useNotificationNamek();
  const { data } = useGetAllAssignMaterials();
  const [isFetching, setIsFetching] = useState(false);

  const isEmptyResult = (data?.length ?? 0) === 0;

  const handleExport = async () => {
    setIsFetching(true);
    try {
      await queryClient.fetchQuery({
        queryKey: ["assignedMaterialsExport"],
        queryFn: async () => exportAssignedMaterials(),
        staleTime: 300000,
      });
      toast.success(DownloadFileSuccessMessage.title);
    } catch (e) {
      toast.error(DownloadFileErrorMessage.title, {
        description: DownloadFileErrorMessage.description,
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Button
      disabled={isEmptyResult}
      icon={<DownloadIcon size={18} />}
      label="Exportar"
      loading={isFetching}
      severity="secondary"
      onClick={handleExport}
    />
  );
}
